import { Pipe, PipeTransform } from '@angular/core';
import { STATUS_LABELS } from '../ui-components/au-cmms-status-label/statuses';

@Pipe({
	name: 'statusLabels',
})
export class StatusLabelsPipe implements PipeTransform {
	transform(status: string): string {
		return STATUS_LABELS[status].name;
	}
}
